import { staticComponentValueConverter } from "../StaticComponentValues";
function BaseDivider({item}) {
  const customization = staticComponentValueConverter(item?.customization)


  return (
    <div className="w-full"
        style={{
            height: customization?.height ,
            background: customization?.backgroundColor
        }}
    >

    </div>
  );
}

export default BaseDivider;